import { Skeleton } from '@/shared/ui/atoms';

/**
 * Skeleton de carregamento da tela **Configuração de Nota e Frequência**.
 *
 * Reflete o layout do conteúdo (barra de contexto + área de cards) enquanto a configuração
 * da turma selecionada é carregada da API, no lugar de um indicador centralizado solto.
 */
export function GradeConfigSkeleton() {
  return (
    <div className="flex flex-col gap-xxs" aria-hidden={false}>
      {/* Barra de contexto */}
      <div className="rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface px-xxxs py-mini">
        <div className="flex flex-wrap items-end gap-xxs">
          <div className="flex flex-1 flex-col gap-quark">
            <Skeleton className="h-mini w-[4rem]" />
            <Skeleton className="h-xxs w-full" />
          </div>
          <div className="flex flex-1 flex-col gap-quark">
            <Skeleton className="h-quark w-[3rem]" />
            <Skeleton className="h-mini w-[8rem]" />
          </div>
        </div>
      </div>

      {/* Abas */}
      <div className="flex gap-xxs">
        <Skeleton className="h-xxs w-[6rem]" />
        <Skeleton className="h-xxs w-[6rem]" />
      </div>

      {/* Cards */}
      <Skeleton className="h-[10rem] w-full" />
      <Skeleton className="h-[14rem] w-full" />
    </div>
  );
}
